import { Outlet } from 'react-router-dom';
import './Layout.css';

export const Layout = () => {
  return (
    <div className="container-layout">
      <main className="main-layout">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
